import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import IPayPaymentState from '../../types/IPayPaymentState'

const mutations: MutationTree<IPayPaymentState> = {
  [types.SET_WIDGET_SESSION_ID] (state, payload: string) {
    state.widgetSessionId = payload
  }
}

export default mutations
